export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function isServer(): boolean {
  return !isBrowser();
}

export function isTouchDevice(): boolean {
  return isBrowser() && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
}

export function isRTL(): boolean {
  if (!isBrowser()) return false;
  return document.documentElement.dir === 'rtl';
}

export function getPlatform(): 'ios' | 'android' | 'mac' | 'windows' | 'linux' | 'web' {
  if (!isBrowser()) return 'web';
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  if (/mac/.test(ua)) return 'mac';
  if (/win/.test(ua)) return 'windows';
  if (/linux/.test(ua)) return 'linux';
  return 'web';
}
